import { Chip } from '@nimbus-ds/components';
import { PROJECT_SHIVA_TAG } from 'App/featuresFlags';
import {
  useGetPlanExpiresIn,
  useGetTags,
  useIsMobileDevice,
} from 'domains/Auth/hooks';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';

export function ExpiresInChip() {
  const t = useTranslationDashboard();
  const isMobile = useIsMobileDevice();
  const expiresIn = useGetPlanExpiresIn();
  const tags = useGetTags();
  const isShivaProject = tags.includes(PROJECT_SHIVA_TAG);
  const showExpiresInChip =
    expiresIn !== undefined && expiresIn > 0 && isMobile;

  if (!showExpiresInChip || isShivaProject) return null;

  return <Chip text={t('header.chip', { count: expiresIn })} />;
}
